import styled from 'styled-components';

export const UploadContainer = styled.div`
  border: 2px dashed #ccc;
  border-radius: 8px;
  padding: 40px;
  text-align: center;
  color: #555;
  background-color: #f8f9fa;
  max-width: 600px;
  margin: 0 auto 20px auto;
  // cursor: pointer;
`;

export const ErrorText = styled.div`
  color: red;
  font-size: 12px;
  margin-top: 8px;
`;

export const UploadText = styled.div`
  font-size: 14px;
  margin-top: 10px;
`;

export const UploadLink = styled.span`
  color: #007bff;
  text-decoration: underline;
  cursor: pointer;
`;

export const MaxSizeText = styled.div`
  font-size: 12px;
  color: #999;
  margin-top: 8px;
`;

export const HiddenInput = styled.input`
  display: none;
`;

export const ImagesPreview = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: center;
  margin-top: 20px;
`;

export const ImageBox = styled.div`
  position: relative;
  width: 100px;
  height: 100px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #ddd;
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const RemoveButton = styled.button`
  position: absolute;
  top: 4px;
  right: 4px;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  border: none;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  cursor: pointer;
  font-size: 12px;
`;
